var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f47ee2c98efc7116fba7e328a271d40b9547861e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["seedlang@seedlang"]={id:"f47ee2c98efc7116fba7e328a271d40b9547861e"};
      